export default __webpack_public_path__ + "static/media/simdustry-icon-logo.5c51cfbe.png";